import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'weathers';
const BASE_PATH = `${API_ROOT}/weathers`;
const PATHS = {
    GET: `${BASE_PATH}/current`,
};
async function get(latitude, longitude) {
    const params = new URLSearchParams();
    params.append('latitude', latitude.toString());
    params.append('longitude', longitude.toString());
    return (await (await SecureAxios()).get(`${PATHS.GET}?${params.toString()}`)).data;
}
function getKey(latitude, longitude) {
    return [CacheKey, 'get', latitude, longitude];
}
export default { CacheKey, get, getKey };
